import React,  { Component } from 'react';

import ModalDropdown from '../ModalDropdown-small/ModalDropdown';

import './styles.css';

class WarehousesSmall extends Component {
    constructor(props) {
        super(props)
        this.state = {
            show: false,
            whsesArray: []
        }
        this.getArray = this.getArray.bind(this);
    }

   
  
    openModal = e => {
        this.setState({
            show: !this.state.show
        });
    }

    onClose = e => {
        this.props.show = false;
    };


    getArray = (array) => {
        this.setState({
            whsesArray: array
        })
        this.props.whsesData(array);
    }


     render() {
        return (
            <div className="dropdown-whse-small-container">
                    <div className="whse-small-input-container">
                        <div className="whse-input"  tabIndex="0">
                        {
                        this.state.whsesArray != undefined ? this.state.whsesArray.slice(0,4).map(whse => {return (<div key={whse} className="whse-div"><p className="whse-label-div">{whse}</p></div>)}) : <div></div>   
                        }
                        </div>
                        <div className="dropdownwhse-small-button" onClick={this.openModal}>
                            <i className="material-icons whse-small-icon">keyboard_arrow_down</i>
                        </div>
                        <ModalDropdown onClose={this.openModal} show={this.state.show} onGetArray={this.getArray}/>
                    </div>
            </div>
          );
     }
}

export default WarehousesSmall;


                             